module.exports = __webpack_public_path__ + "img/Frame 1103hrp-m2.655eabbd.png";